import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getEmirBreakdown } from '../emir.routes';
import type { EmirOverviewPageModel } from '../types';

export const emirBreakdownQueryKey = (positionDate?: string) =>
  ['emir-breakdown', positionDate] as const;

export const useEmirBreakdownQuery = (
  positionDate?: string,
  options?: Omit<
    UseQueryOptions<EmirOverviewPageModel, Error>,
    'queryKey' | 'queryFn' | 'enabled'
  >,
) => {
  return useQuery<EmirOverviewPageModel, Error>({
    queryKey: emirBreakdownQueryKey(positionDate),
    queryFn: () => getEmirBreakdown(positionDate),
    enabled: !!positionDate && (options?.enabled ?? true),
    staleTime: 5 * 60 * 1000,
    ...options,
  });
};
